import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

//Service Workers
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

//Router
import { BrowserRouter } from "react-router-dom";

//Redux
import store from "./store/store";
import { Provider } from "react-redux";

//AntDesign Cofig Imports
import { ConfigProvider } from "antd";


//Set Persian Interface
import localeValues from 'antd/es/locale/fa_IR';

//Set Jalali Calender
import {JalaliLocaleListener} from 'antd-jalali'
import dayjs from "dayjs";
import 'dayjs/locale/fa'


//Root To Render
const root = ReactDOM.createRoot(document.getElementById("root"));

//Ant Design Config
ConfigProvider.config({
  theme: {
  primaryColor: '#1890ff',

},})
dayjs.locale('fa')
root.render(
  <Provider store={store}>
    <BrowserRouter>
   
        <ConfigProvider  direction="rtl" locale={localeValues}>
        <JalaliLocaleListener/>
          <App />
        </ConfigProvider>
   
    </BrowserRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// eslint-disable-next-line no-extend-native
String.prototype.toPersianDigit = function () {
  var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  return this.replace(/[0-9]/g, function (w) {
    return id[+w];
  });
};